export default "__VITE_ASSET__DKeQ1NH___"